export default __webpack_public_path__ + "static/media/ReportCover.38dab8dc.png";